export const breadcrumbs = {
  breadcrumbHome: "首页",
  breadcrumbCasino: "赌场",
  breadcrumbLottery: "彩票",
  breadcrumbRaffles: "抽奖",
  breadcrumbNews: "新闻",
  breadcrumbArticle: "文章",
  breadcrumbSports: "体育",
  breadcrumbGameFeed: "游戏动态",
  breadcrumbMyTickets: "我的票",
  breadcrumbResults: "结果",
  breadcrumbAllGames: "所有游戏",
  breadcrumbGames: "游戏",
  breadcrumbTerms: "条款和条件",
  breadcrumbDeleteAccount: "删除账户",
  breadcrumbProfile: "个人资料",
  breadcrumbProvider: "供应商",
  breadcrumbHorses: "赛马",
  breadcrumbMiniJuegos: "迷你游戏",
  breadcrumbFavorites: "收藏",
};
